import { on as t, off as s } from "../../../../evtd@0.2.4/node_modules/evtd/es/delegate.js";
const d = "@@mmoContext", m = {
  mounted(o, { value: e }) {
    o[d] = {
      handler: void 0
    }, typeof e == "function" && (o[d].handler = e, t("mousemoveoutside", o, e));
  },
  updated(o, { value: e }) {
    const n = o[d];
    typeof e == "function" ? n.handler ? n.handler !== e && (s("mousemoveoutside", o, n.handler), n.handler = e, t("mousemoveoutside", o, e)) : (o[d].handler = e, t("mousemoveoutside", o, e)) : n.handler && (s("mousemoveoutside", o, n.handler), n.handler = void 0);
  },
  unmounted(o) {
    const { handler: e } = o[d];
    e && s("mousemoveoutside", o, e), o[d].handler = void 0;
  }
}, u = m;
export {
  u as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vdirs@0.1.8_vue@3.5.18/~/vdirs/es/mousemoveoutside.js
// module id = 1733
// module chunks = 41